import { STOCK_STATUSES, STOCK_TYPES } from 'constants/all';

import { getActivePartFileStatus } from 'modules/common/forms/materialWidget/data/reducer';

import { types } from './actions';

const initialState = {
  hasSubmitted: false,
  isFetchingResult: false,
  result: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.RESET:
      return {
        ...initialState,
      };
    case types.RECEIVE_RESULT:
      return {
        ...state,
        result: payload.result,
      };
    case types.STOCK_REQUEST_ERROR:
    case types.STOCK_REQUEST_SUCCESS:
      return {
        ...state,
        isFetchingResult: false,
      };
    case types.STOCK_REQUEST_SUBMIT:
      return {
        ...state,
        hasSubmitted: true,
        isFetchingResult: true,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.common.forms.materialWidget.bar;

export const getHasSubmitted = (state) => getScope(state).hasSubmitted;

export const getIsFetchingResult = (state) => getScope(state).isFetchingResult;

export const getIsInterrogating = (state) => {
  const status = getActivePartFileStatus(state);
  if (status) {
    return status[STOCK_TYPES.RECTANGULAR] === STOCK_STATUSES.INTERROGATING;
  } else {
    return false;
  }
};

export const getResult = (state) => getScope(state).result;

export default reducer;
